module.exports = __webpack_public_path__ + "static/img/bg-id.3972c525.png";